"use client";
import { BASE_URL } from "@/util/api";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Client = ({ props, title }: any) => {
  const [clients, setClients] = useState<any>([]);

  const fetchClients = async () => {
    try {
      const response = await axios.get(`${BASE_URL}our-clients/`);
      setClients(response?.data?.client[0]?.client_list || []);
    } catch (error) {
      console.error("Error fetching clients:", error);
    }
  };

  useEffect(() => {
    fetchClients();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 5 } },
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 640, settings: { slidesToShow: 2 } },
    //   { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };
  return (
    <div className="2xl:w-[76%]  mx-auto w-[95%] xl:w-[95%] px-4">
      <div className="text-homeblack text-center 2xl:w-[76%] w-[98%] xl:w-[95%] mx-auto my-8" dangerouslySetInnerHTML={{__html:title}}/>
      <div className="my-8  mx-auto border-2 rounded-2xl py-4 sm:p-4 border-lightblue">
        <Slider {...settings}>
          {(props?.cards || clients.slice(0, 6)).map((elem: any, i: number) => (
            <div
              key={i}
              className="
              !flex w-[145px] xl:w-[165px] h-[120px] p-1 group sm:size-[181px] !justify-center !items-center border-[1px] border-slate-100 rounded-sm"
          >
              <Image
                src={elem?.image}
                alt={elem?.image_alt || "Client logo"}
                height={95}
                width={180}
                className="grayscale !w-[130px] md:max-w-[160px] lg:w-[180px] group-hover:grayscale-0 transition duration-100 ease-in-out"
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Client;
